import { render, staticRenderFns } from "./ImportScopus.vue?vue&type=template&id=1f26bec9&scoped=true"
import script from "./ImportScopus.vue?vue&type=script&lang=js"
export * from "./ImportScopus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f26bec9",
  null
  
)

export default component.exports